module.exports = __webpack_public_path__ + "img/f6-4.b4d37247.png";